import {ref} from 'vue'
import { shoppingCartService } from '@/services/shoppingCartService'
export function useShoppingCartApi() {
  const isLoading = ref(false);
  const error = ref(null);
  const service = shoppingCartService();

  async function fetchCart() {
    isLoading.value = true;
    error.value = null;

    try {
      return await service.fetchCart();
    } catch (err) {
      error.value = err;
    } finally {
      isLoading.value = false;
    }
  }

  async function createCart() {
    try {
      isLoading.value = true;
      error.value = null;

      return await service.createCart();
    } catch (err) {
      error.value = err;
    } finally {
      isLoading.value = false;
    }

  }

  async function fetchOrCreateShoppingCart() {
    if (isLoading.value) {
      return;
    }

    isLoading.value = true;
    error.value = null;

    try {
      return await service.fetchOrCreateShoppingCart();
    } catch (err) {
      error.value = err;
    } finally {
      isLoading.value = false;
    }
  }

  /**
   *
   * @param {String} sku
   * @param {String} name
   * @param {String} quantity
   */
  async function updateCart(sku, name, quantity) {
    if (isLoading.value) {
      return;
    }

    isLoading.value = true;
    error.value = null;

    try {
      return await service.updateCart({sku, name, quantity});
    } catch (err) {
      error.value = err
    } finally {
      isLoading.value = false;
    }
  }

  /**
   * 
   * @param {String} sku 
   */
  async function deleteCartItem(sku) {
    if (isLoading.value) {
      return;
    }

    isLoading.value = true;
    error.value = null;

    try {
      return await service.deleteCartItem({sku});
    } catch (err) {
      error.value = err
    } finally {
      isLoading.value = false;
    }
  }

  return {
    fetchCart,
    createCart,
    fetchOrCreateShoppingCart,
    updateCart,
    deleteCartItem,
    isLoading,
    error
  }
}
